<template>
  <div class="sk-spinner sk-spinner-double-bounce" :class="{ 'displayNone': displayNone }">
    <div class="sk-double-bounce1"></div>
    <div class="sk-double-bounce2"></div>
  </div>
</template>

<script>
  export default {
    name: "SpinnerDoubleBounce",

    props: {
      displayNone: {
        type: Boolean
      }
    }
  }
</script>

<style scoped>

</style>
